import React, { useEffect } from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';
import { useTranslation } from '../../i18n/LanguageContext';
import { Section } from '../shared/LegalPagesections';


const THEME_COLOR = '#1d659c';

function PrivacyPolicy() {
  const { t } = useTranslation();
  const pp = t('privacyPolicy');

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <Container maxWidth="md">
      <Box sx={{ my: 4 }}>
        <Paper elevation={2} sx={{ p: { xs: 3, md: 5 } }}>
          <Typography variant="h3" component="h1" gutterBottom sx={{ color: THEME_COLOR, fontWeight: 700, fontSize: { xs: '1.8rem', md: '3rem' } }}>
            {pp.title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            {pp.lastUpdate}
          </Typography>
          {pp.intro && (
            <Typography variant="body1" paragraph>
              {pp.intro}
            </Typography>
          )}
          {Object.values(pp.sections).map((section, idx) => (
            <Section key={idx} section={section} color={THEME_COLOR} />
          ))}
        </Paper>
      </Box>
    </Container>
  );
}

export default PrivacyPolicy;